import { Link } from 'react-router-dom';
import { specials } from '@/mocks/specials';
import SectionTitle from '@/components/base/SectionTitle';

export default function SpecialsSection() {
  const list = specials.slice(0, 3);

  return (
    <section className="mt-14">
      <SectionTitle
        eyebrow="Special Topics"
        icon="ri-book-marked-line"
        title="相关专题推荐"
        description="按主题脉络串联影片与影评，帮你在阅读中建立完整的知识框架。"
        moreTo="/special"
        moreLabel="全部专题"
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {list.map((s) => (
          <Link
            key={s.id}
            to="/special"
            className="group rounded-lg overflow-hidden border border-background-200/80 bg-background-50 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <div className="relative w-full h-40 overflow-hidden bg-background-200">
              <img
                src={s.cover}
                alt={`${s.title} 专题主图`}
                title={s.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 to-transparent" />
              <span className="absolute bottom-3 left-3 rounded-full bg-accent-500 px-2.5 py-0.5 font-label text-[11px] font-bold text-primary-950">
                {s.movieIds.length} 部影片
              </span>
            </div>
            <div className="p-4 md:p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
                {s.title}
              </h3>
              <p className="mt-1 text-xs text-accent-700">{s.subtitle}</p>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-3">{s.intro}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}